module.exports = __webpack_public_path__ + "img/breakfast_bars.00d1dc0c.png";